import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./DifferenceSection.css";

// const differences = [
//   {
//     icon: "/icons/uv-protection.png",
//     title: "100% UV Protection",
//     desc: "Shield your eyes with industry-leading UV-blocking lens technology.",
//   },
//   {
//     icon: "/icons/luxury-craftmanship.png",
//     title: "Luxury Craftsmanship",
//     desc: "Precision-made frames using premium materials for lasting comfort.",
//   },
//   {
//     icon: "/icons/polarized-clarity.png",
//     title: "Polarized Clarity",
//     desc: "Experience glare-free clarity with advanced polarized lenses.",
//   },
// ];

const DifferenceSection = ({cardContent, cardContentHeading}) => {
  return (
    <section className="difference-section pb-5">
      <Container>
        <h2 className="text-center mb-5">
          {cardContentHeading.heading} <span>{cardContentHeading.headingGold}</span>
        </h2>
        <Row className="g-4">
          {cardContent.map((item, index) => (
            <Col md={4} key={index}>
              <Card className="difference-card text-center p-4">
                <div className="icon-wrap mb-3">
                  <img src={item.icon} alt={item.title} />
                </div>
                <h5>{item.title}</h5>
                <p>{item.desc}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default DifferenceSection;
